import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { TripleAction, Footer } from '../../libs/gs-component-right-rail';
import { RightRailContext } from '../../components/PageItemsRail';
import { useWeddingWebsiteQuery } from '../../generated/graphql';

interface Props {
  primaryOnClick: () => void;
  primaryText?: string;
  secondaryText?: string;
  secondaryOnClick?: () => void;
  showSpinner: boolean;
  className?: string;
  useSaveAndPreview?: boolean;
  buttonsSize?: 'sm' | 'md' | 'lg';
  footerContainerClassOverride?: string;
  primaryDisabled?: boolean;
}

const FormFooter: React.FC<Props> = ({
  primaryOnClick,
  primaryText,
  secondaryText = 'Cancel',
  secondaryOnClick,
  className = '',
  showSpinner,
  useSaveAndPreview = false,
  buttonsSize = 'md',
  footerContainerClassOverride,
  primaryDisabled = false,
}) => {
  const location = useLocation();
  const { previewAfterSave, closeAfterSave } = useContext(RightRailContext);
  const { data } = useWeddingWebsiteQuery();
  const isPublished = data?.weddingWebsite?.state === 'published';
  const saveText = isPublished ? 'Save & publish' : 'Save';
  // if primaryText is not provided, use saveText
  const primaryButtonText = primaryText || saveText;

  const primaryAction = async () => {
    if (showSpinner) {
      return;
    }
    if (useSaveAndPreview) {
      previewAfterSave();
    }
    primaryOnClick();
  };

  const secondaryAction = () => {
    if (showSpinner) {
      return;
    }
    if (useSaveAndPreview) {
      closeAfterSave();
      primaryOnClick();
    } else if (secondaryOnClick) {
      secondaryOnClick();
    }
  };

  if (location.pathname.includes('preview')) {
    // If we are on preview, we don't want the action to be "Save & Preview",
    // just "Save & Close"
    useSaveAndPreview = false;
  }

  return (
    <Footer className={footerContainerClassOverride}>
      <TripleAction
        primaryOnClick={primaryAction}
        primaryText={primaryButtonText}
        secondaryOnClick={secondaryAction}
        secondaryText={useSaveAndPreview ? 'Save & Close' : secondaryText}
        showSpinner={showSpinner}
        className={className}
        buttonsSize={buttonsSize}
        primaryDisabled={primaryDisabled}
      />
    </Footer>
  );
};

export default FormFooter;
